import React, { useCallback } from 'react';
import { View } from 'react-native';
import {
  Button,
  ContractSellerButton,
  DefaultScreenContainer,
  ServicePriceCard,
  Text,
} from '~/components';

import Banner from '~/scenes/MarisaTakesCare/components/Banner';
import Footer from '../Footer';
import { marisaTakesCareResumeItems } from '~/utils/services';
import { TakesCareComponents } from '~/components/TakesCare';
import { isWeb } from '~/utils/device';
import { useTakesCareFormStore } from '~/stores/marisaTakesCareForm';
import { useCheckout } from '~/stores';
import type { StepComponentProps } from '~/components/StepsForm';

const INSURANCE_TYPE = 'marisa-cuida';

const FourthStep: React.FC<StepComponentProps> = ({ onContinue }) => {
  const { setInsuranceFormData, setContractSeller } = useCheckout();
  const { states: form } = useTakesCareFormStore();

  const handleSetInsuranceFormData = useCallback(() => {
    setInsuranceFormData(form);
  }, [form, setInsuranceFormData]);

  const handleContinue = useCallback(() => {
    handleSetInsuranceFormData();

    setContractSeller(null);

    onContinue?.();
  }, [handleSetInsuranceFormData, onContinue, setContractSeller]);

  return (
    <>
      <DefaultScreenContainer>
        <View className="flex-1 container mx-auto xl:flex-row  xl:pt-12 xl:pb-24">
          <Banner showButton={false} />

          <View className="mt-8 xl:mt-0 px-6 flex-1 xl:ml-24">
            <Text className="text-xl mb-1 text-gray-600">
              Resumo da contratação
            </Text>

            <Text className="text-primary-600 text-xs mb-6">
              Assistência Marisa Cuida
            </Text>

            <ServicePriceCard value=" 29,90" />

            <View className="mb-6">
              {marisaTakesCareResumeItems.map((item, index) => (
                <TakesCareComponents.ResumeItem {...item} key={index} />
              ))}
            </View>

            {isWeb && (
              <Button className="hidden xl:flex mt-6" onPress={handleContinue}>
                CONTINUAR PARA PAGAMENTO
              </Button>
            )}

            <ContractSellerButton
              type={INSURANCE_TYPE}
              beforeNavigate={handleSetInsuranceFormData}
            />
          </View>
        </View>
      </DefaultScreenContainer>

      <View className="flex xl:hidden">
        <Footer
          buttonLabel="CONTINUAR PARA PAGAMENTO"
          onSubmit={handleContinue}
        />
      </View>
    </>
  );
};

export default FourthStep;
